import { SetLoading } from "common/components/Loader/Loader";
import RobotsNoIndex from "common/components/RobotsNoIndex";
import { GetCurrentGamePrefix } from "common/constants/Games";
import { LocalStorageKeys } from "common/constants/StorageKeys";
import { changeUrl, consumeQueryParam } from "common/history";
import Store from "common/store";
import StoreKeys from "common/storeKeys";
import UserManager from "common/userManager";
import React from "react";
import { redditSignIn } from "./api";

export default class SignInReddit extends React.Component {
	async componentDidMount() {
		SetLoading(true, "Signing in with Reddit");

		const code = consumeQueryParam("code");
		if (code === null) {
			SetLoading(false);
			changeUrl(GetCurrentGamePrefix() + "/event");
			return;
		}

		try {
			const result = await redditSignIn(code);
			UserManager.handlePostLogin(result);
			const route = GetCurrentGamePrefix();

			SetLoading(false);
			if (result.usernameIsEmail) {
				changeUrl(route + "/event");
			} else if (result.created) {
				Store.set(StoreKeys.LOGIN_PROVIDER, "reddit");
				changeUrl("/pick-username");
			} else {
				const redirect = localStorage.getItem(LocalStorageKeys.POSTLOGINURL);
				if (redirect) {
					localStorage.removeItem(LocalStorageKeys.POSTLOGINURL);
					changeUrl(redirect);
				} else {
					changeUrl(route + "/event");
				}
			}
		} catch (error) {
			SetLoading(false);
			const route = GetCurrentGamePrefix();
			changeUrl(route + "/event");
		}
	}

	render() {
		return <RobotsNoIndex />;
	}
}
